import React, { useState, useEffect } from 'react';
import './Navbar.css';
import { FaBars, FaTimes } from 'react-icons/fa';

const Navbar = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
      {isMobileMenuOpen && <div className="navbar-overlay" onClick={() => setIsMobileMenuOpen(false)}></div>}
      <div className="navbar-container container">
        <div className="navbar-logo" onClick={() => scrollToSection('hero')}>
          <img src="/website/grandislogo_white.png" alt="Grandis Solutions" className="logo-image" />
          <div className="logo-text">
            <span className="logo-main">Grandis</span>
            <span className="logo-sub">Business Solutions</span>
          </div>
        </div>

        <div className={`navbar-menu ${isMobileMenuOpen ? 'active' : ''}`}>
          <a href="#home" onClick={() => scrollToSection('hero')}>Home</a>
          <a href="#about" onClick={() => scrollToSection('about')}>About</a>
          <a href="#products" onClick={() => scrollToSection('products')}>Products</a>
          <a href="#features" onClick={() => scrollToSection('features')}>Features</a>
          <a href="#contact" onClick={() => scrollToSection('contact')}>Contact</a>
          <button className="btn-primary" onClick={() => scrollToSection('contact')}>
            Get Started
          </button>
        </div>

        <div className="navbar-toggle" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}>
          {isMobileMenuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
